<template>
  <v-app>
    <navbar />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    Navbar,
  },
  data: () => ({
    url: process.env.VUE_APP_STRAPI_URL,
    //
  }),
  computed: {
    ...mapGetters(["getPageTitle", "layoutGetter"]),
  },
  methods: {
    handlePageTitle() {
      let title = localStorage.getItem("pageTitle");
      if (title) {
        document.title = title;
      } else {
        document.title = this.getPageTitle;
      }
    },
  },
  mounted() {
    this.handlePageTitle();
    // this.updateMetaTags();
  },
};
</script>

<style lang="scss">
.v-application {
  [class*="text-"] {
    color: #36405a;
    font-family: Tahoma, Tahoma Armenian, Arial Unicode, -apple-system,
      BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans,
      sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol,
      Noto Color Emoji !important;
  }
  font-family: Tahoma, Tahoma Armenian, Arial Unicode, -apple-system,
    BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol,
    Noto Color Emoji !important;
}
</style>
